var map = {
	"./lestnica_vneshnyaya_ulichnaya.svg": "18a4",
	"./lestnica_vneshnyaya_ulichnaya_mirror.svg": "3509",
	"./lestnica_vnutrennyaya.svg": "c556",
	"./ploschadka_2_y_etazh.svg": "528d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6040";